// extracted by mini-css-extract-plugin
module.exports = {"link":"link--oWxaF"};
    if(module.hot) {
      // 1653630376701
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  